import { fetchWithRefresh } from "../../api/FetchWithRefresh";
import { useEffect, useState } from "react";
import type { paths } from "../../api/generated/api-types";

type ListSiteRegionsResponse =
  paths["/sites/regions"]["get"]["responses"]["200"]["content"]["application/json"];

export type RegionsState =
  | { kind: "loading" }
  | { kind: "error" }
  | { kind: "loaded"; regions: string[] };

const CHANNELS = ["article", "homepage"] as const;

async function fetchChannelRegions(channel: string): Promise<string[]> {
  const response = await fetchWithRefresh(`/api/sites/regions?credentialType=${channel}`);
  if (!response.ok) {
    throw new Error(`regions request failed: ${response.status}`);
  }
  const data = (await response.json()) as ListSiteRegionsResponse;
  return data.regions.filter((row) => row.geoGroup !== "secondary").map((row) => row.region);
}

// Same selectable set as task creation: regions valid for a publication channel,
// excluding the secondary geo group. The list filter spans all task types, so it
// unions both channels (article + homepage).
export function useTaskListRegions(): RegionsState {
  const [state, setState] = useState<RegionsState>({ kind: "loading" });

  useEffect(() => {
    let active = true;
    setState({ kind: "loading" });
    Promise.all(CHANNELS.map((channel) => fetchChannelRegions(channel)))
      .then((perChannel) => {
        if (!active) {
          return;
        }
        const unique = Array.from(new Set(perChannel.flat())).sort();
        setState({ kind: "loaded", regions: unique });
      })
      .catch(() => {
        if (active) {
          setState({ kind: "error" });
        }
      });
    return () => {
      active = false;
    };
  }, []);

  return state;
}
